<style>
  .om61InventoryTable .el-input__inner {
    text-align: center;
  }

  .form-group .om61InventoryTable .el-form-item {
    margin-top: 11px !important;
  }

  .om61-recycler-status {
    position: relative;
    margin-bottom: 0;
    font-size: 14px;
  }
</style>

<template>
    <div>
      <el-table :data="om61InventorySettings" class="om61InventoryTable" style="width: 100%;">
        <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.denomination')" min-width="10%" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.denomination.toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.numberOfRecyclers')" min-width="8%" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.numberOfRecyclers" filterable :disabled="!overridden || readOnly" @change="recyclersUpdated(scope.row)">
              <el-option
                  @click.native="forceUpdate()"
                  v-for="(value, index) in (maxNumberOfRecyclers+1)"
                  :value="index">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.min')" min-width="8%" align="center">
          <template slot-scope="scope">
            <el-form-item class="custom-label">
              <el-input v-model="scope.row.minAmount" type="number" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.optimum')" min-width="8%" align="center">
          <template slot-scope="scope">
            <el-form-item class="custom-label">
              <el-input v-model="scope.row.optimumAmount" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.max')" min-width="8%" align="center">
          <template slot-scope="scope">
            <el-form-item class="custom-label">
              <el-input :key="rowUpdateKey" v-model="scope.row.maxAmount" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
      <el-form-item>
        <p v-bind:class="[status.class]">{{status.message}}</p>
      </el-form-item>
      <el-form-item prop="om61SettingsValid" v-show="false">
        <el-input v-model="form.om61SettingsValid" type="text" ></el-input>
      </el-form-item>
    </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'DqOm61Inventorypanel',
    replace: true,
    props: {
      label: '',
      valueColumn: true,
      overridden: false,
      acceptableMaterials: [],
      recyclerSettings: [],
      unitTypeUuid: '',
      readOnly: false,
      form: {},
      formRules: {},
      currency: {
        default: {iso3: 'EUR'}
      }
    },
    data: function () {
      return {
        om61InventorySettings: [],
        om61DefaultInventorySettings: [],
        maxNumberOfRecyclers: 0,
        denominations: [],
        status: '',
        rowUpdateKey: 0,
        overviewParams: {pagesize: 0}
      }
    },
    created () {
      this.initializeData()
    },
    mounted () {
      this.updateSettings()
    },
    methods: {
      initializeData () {
        const self = this
        self.getCurrency(self, currency => {
          self.getEnabledDenominations(self, currency, denominations => {
            self.getDefaultInventorySettings(self, unitTypeSettings => {
              self.initializeOm61InventorySettings(self, denominations, unitTypeSettings)
            })
          })
        })
      },
      getCurrency (self, callback) {
        if (self.currency.uuid === undefined) {
          self.$dataApi().endpoints.currency.getAllEnabled(self.overviewParams).then((response) => {
            if (response.status === 200) {
              const resultCurrency = response.body.items
              self.currency = resultCurrency.find(({iso3}) => iso3 === self.currency.iso3)
              callback(self.currency)
            }
          }, (response) => {
            self.redirectToError('could_not_load', response.body.message)
          })
        } else {
          callback(self.currency)
        }
      },
      getEnabledDenominations (self, currency, callback) {
        const denominationsParams = {
          currencyUuid: currency.uuid
        }
        self.$dataApi().endpoints.currency.getCurrencyDenominations(denominationsParams).then((denominationsresponse) => {
          if (denominationsresponse.status === 200) {
            const allDenominations = denominationsresponse.body
            self.denominations = allDenominations.filter(d => d.material === 'BIL')
                .filter(d => d.enabled)
                .map(d => d.value)
            callback(self.denominations)
          }
        }, (denominationsresponse) => {
          self.redirectToError('could_not_load', denominationsresponse.body.message)
        })
      },
      getDefaultInventorySettings (self, callback) {
        const params = {
          unitTypeUuid: self.unitTypeUuid
        }

        self.$dataApi().endpoints.softwaresettings.getDefaultSettings(params).then((response) => {
          if (response.status === 200) {
            const settings = response.body['settingsList']
            const inventorySettings = settings.find(({ key }) => key === 'inventorySettings')
            const acceptableMaterials = JSON.parse(inventorySettings['value']).acceptableMaterials
            self.om61DefaultInventorySettings = acceptableMaterials.filter(m => m.placeholder === 'om61')
            self.om61DefaultInventorySettings.forEach(m => {
              m.denomination.value = parseInt(m.denomination.value)
            })
            callback(self.om61DefaultInventorySettings)
          }
        }, (response) => {
          self.redirectToError('could_not_load', response.body.message)
        })
      },
      initializeOm61InventorySettings (self, denominations, unitTypeSettings) {
        const denominationsForCurrency = denominations
        this.$store.commit('denominationForCurrency/setDenominationsForCurrency',
        { denominationsForCurrency })

        self.maxNumberOfRecyclers = JSON.parse(self.recyclerSettings.value).maxNumberOfRecyclers
        const recyclerSettings = JSON.parse(self.recyclerSettings.value).settings || []
        const om61Materials = self.acceptableMaterials.filter(m => m.placeholder === 'om61')
        self.om61InventorySettings = []
        for (let i = 0; i < denominations.length; i++) {
          const denomination = denominations[i]
          const numberOfRecyclers = self.calculateRecyclers(self, recyclerSettings, denomination)
          let om61Material = om61Materials.find(r => parseInt(r.denomination.value) === denomination)
          if (om61Material === undefined) {
            om61Material = unitTypeSettings.find(r => parseInt(r.denomination.value) === denomination)
          }
          self.om61InventorySettings.push({
            numberOfRecyclers: numberOfRecyclers,
            denomination,
            minAmount: (numberOfRecyclers === 0 || om61Material === undefined) ? 0 : om61Material.minAmount,
            maxAmount: (numberOfRecyclers === 0 || om61Material === undefined) ? 0 : om61Material.maxAmount,
            optimumAmount: (numberOfRecyclers === 0 || om61Material === undefined) ? 0 : om61Material.optimumAmount
          })
        }
        this.formRules.om61SettingsValid = [ { required: true } ]
        self.updateStatus()
        this.updateSettings()
      },
      calculateRecyclers (self, recyclerSettings, denomination) {
        const t = recyclerSettings.find(r => parseInt(r.denomination.value) === denomination)
        if (t === undefined) {
          if (recyclerSettings.length === 0) {
            const totalRecyclers = self.getTotalUsedRecyclers()
            return totalRecyclers < self.maxNumberOfRecyclers ? 1 : 0
          } else {
            return 0
          }
        } else {
          return t.numberOfRecyclers
        }
      },
      recyclersUpdated (recyclerDataRow) {
        const defaultValues = this.om61DefaultInventorySettings
                .find(m => parseInt(m.denomination.value) === parseInt(recyclerDataRow.denomination))
        if (defaultValues != null) {
          recyclerDataRow.minAmount = defaultValues.minAmount * recyclerDataRow.numberOfRecyclers
          recyclerDataRow.maxAmount = defaultValues.maxAmount * recyclerDataRow.numberOfRecyclers
          recyclerDataRow.optimumAmount = defaultValues.optimumAmount * recyclerDataRow.numberOfRecyclers
        }
        this.updateStatus()
        this.updateSettings()
        this.forceUpdate()
      },
      updateSettings () {
        const inventorySettings = []
        const recyclerSettings = {
          maxNumberOfRecyclers: this.maxNumberOfRecyclers,
          settings: []
        }
        this.om61InventorySettings
        .filter(s => s.numberOfRecyclers !== 0)
        .forEach(s => {
          const denomination = {
            value: s.denomination,
            currency: this.currency.iso3,
            material: 'BILL'
          }
          inventorySettings.push({
            placeholder: 'om61',
            minAmount: s.minAmount,
            maxAmount: s.maxAmount,
            optimumAmount: s.optimumAmount,
            recycled: true,
            denomination
          })
          recyclerSettings.settings.push({
            numberOfRecyclers: s.numberOfRecyclers,
            denomination
          })
        })

        this.$store.commit('overrideOm61InventorySettings/setOverrideOm61InventorySettings',
        { inventorySettings, recyclerSettings })
      },
      forceUpdate () {
        this.rowUpdateKey += 1
      },
      updateStatus () {
        const totalRecyclers = this.getTotalUsedRecyclers()
        if (totalRecyclers <= this.maxNumberOfRecyclers) {
          this.status = {
            message: Vue.t('management.unit.softwaresettings.inventorypanel.messages.recyclerStatusInfo',
                {totalRecyclers, maxNumberOfRecyclers: this.maxNumberOfRecyclers}),
            class: 'om61-recycler-status'
          }
          this.form.om61SettingsValid = 'true'
        } else {
          this.status = {
            message: Vue.t('management.unit.softwaresettings.inventorypanel.messages.recyclerStatusError',
                {totalRecyclers, maxNumberOfRecyclers: this.maxNumberOfRecyclers}),
            class: 'el-form-item__error om61-recycler-status'
          }
          this.form.om61SettingsValid = undefined
        }
      },
      getTotalUsedRecyclers () {
        return this.om61InventorySettings
            .map(s => s.numberOfRecyclers)
            .reduce((a, b) => a + b, 0)
      }
    },
    watch: {
      currency: {
        handler () {
          this.initializeData()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// om61inventorypanel.vue?33ba9d97